export const EXEC_ROLES = [
  'ROLE_ADMIN',
  'ROLE_EXECS',
  'ROLE_LIBERTY_ACCOUNTING',
  'ROLE_REFUND_APPROVAL',
]

export const REFUND_REVIEW_ROLES = [
  ...EXEC_ROLES,
  'ROLE_CUSTOMER_SERVICE',
  'ROLE_CUSTOMER_SERVICE_MANAGER',
]

export const CHECK_ROLES = [
  'ROLE_ADMIN',
  'ROLE_EXECS',
  'ROLE_LIBERTY_DEFAULTS',
  'ROLE_LIBERTY_ACCOUNTING',
  'ROLE_REFUND_APPROVAL',
]
